import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Box } from 'foundations-components/transitional/components/Box';
import PropTypes from 'prop-types';
import PermissionsTooltip from '../PermissionsTooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const I18N_PREFIX = 'knowledgeContentUI.importArticles.panel';
const CancelImportButton = ({
  canWriteArticle,
  langKey,
  onClick
}) => /*#__PURE__*/_jsx(PermissionsTooltip, {
  disabled: canWriteArticle,
  children: /*#__PURE__*/_jsx(Box, {
    grow: 0,
    marginInlineStart: "400",
    children: /*#__PURE__*/_jsx(Button, {
      disabled: !canWriteArticle,
      onClick: onClick,
      use: "link",
      marginBlockEnd: "100",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${I18N_PREFIX}.${langKey}.button`
      })
    })
  })
});
CancelImportButton.propTypes = {
  canWriteArticle: PropTypes.bool.isRequired,
  langKey: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};
export default CancelImportButton;